"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRemoveAreaManagerMutation = exports.useAddAreaManagersMutation = exports.useDeleteAreaMutation = exports.useUpdateAreaMutation = exports.useCreateAreaMutation = exports.useGetAreasQuery = exports.useGetAreaQuery = exports.areaApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
var client_scoped_query_1 = require("../../utils/client-scoped-query");
exports.areaApi = (0, react_1.createApi)({
    reducerPath: "areaApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["area"],
    endpoints: function (builder) { return ({
        getArea: builder.query({
            query: function (id) { return "/v1/area/".concat(id); },
            providesTags: ["area"],
        }),
        getAreas: builder.query({
            queryFn: (0, client_scoped_query_1.clientScopedQueryFn)("/v1/area", function (arg) { return ({
                facility_id: arg.facilityId,
            }); }),
            providesTags: ["area"],
        }),
        createArea: builder.mutation({
            query: function (_a) {
                var facilityId = _a.facilityId, areaLibraryIds = _a.areaLibraryIds;
                return ({
                    url: "/v1/area",
                    method: "POST",
                    body: { facility_id: facilityId, area_library_ids: areaLibraryIds },
                });
            },
            invalidatesTags: ["area"],
        }),
        updateArea: builder.mutation({
            query: function (_a) {
                var id = _a.id, changes = __rest(_a, ["id"]);
                return ({ url: "/v1/area/".concat(id), method: "PATCH", body: changes });
            },
            invalidatesTags: ["area"],
        }),
        deleteArea: builder.mutation({
            query: function (_a) {
                var id = _a.id;
                return ({ url: "/v1/area/".concat(id), method: "DELETE" });
            },
            invalidatesTags: ["area"],
        }),
        addAreaManagers: builder.mutation({
            query: function (_a) {
                var areaId = _a.areaId, managerIds = _a.managerIds;
                return ({ url: "/v1/area/".concat(areaId, "/managers"), method: "POST", body: { manager_ids: managerIds } });
            },
            invalidatesTags: ["area"],
        }),
        removeAreaManager: builder.mutation({
            query: function (_a) {
                var areaId = _a.areaId, managerId = _a.managerId;
                return ({ url: "/v1/area/".concat(areaId, "/managers/").concat(managerId), method: "DELETE" });
            },
            invalidatesTags: ["area"],
        }),
    }); },
});
exports.useGetAreaQuery = exports.areaApi.useGetAreaQuery, exports.useGetAreasQuery = exports.areaApi.useGetAreasQuery, exports.useCreateAreaMutation = exports.areaApi.useCreateAreaMutation, exports.useUpdateAreaMutation = exports.areaApi.useUpdateAreaMutation, exports.useDeleteAreaMutation = exports.areaApi.useDeleteAreaMutation, exports.useAddAreaManagersMutation = exports.areaApi.useAddAreaManagersMutation, exports.useRemoveAreaManagerMutation = exports.areaApi.useRemoveAreaManagerMutation;
